(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/onboarding/image-helpers/assets/javascripts/svg-image.js') >= 0) return;  svs.modules.push('/components/onboarding/image-helpers/assets/javascripts/svg-image.js');
"use strict";

const _React = React,
  useContext = _React.useContext,
  forwardRef = _React.forwardRef;
const cdn = svs.core.config.data.svsconfig.cdn;
const ImageContext = svs.components.onboarding.imageHelpers.ImageContext;


const SvgImage = forwardRef((_ref, ref) => {
  let alt = _ref.alt,
    imagePath = _ref.imagePath,
    className = _ref.className,
    onLoad = _ref.onLoad,
    _ref$isLazy = _ref.isLazy,
    isLazy = _ref$isLazy === void 0 ? false : _ref$isLazy;
  const _useContext = useContext(ImageContext),
    useLazyImage = _useContext.useLazyImage;
  const baseClassname = 'pg_content__img';
  const classNames = className ? "".concat(baseClassname, " ").concat(className) : baseClassname;
  const src = "".concat(cdn, "/images/onboarding/").concat(imagePath);
  const LazyImage = useLazyImage(src, !isLazy);
  return React.createElement(LazyImage, {
    alt: alt,
    className: classNames,
    onLoad: onLoad,
    ref: ref,
    src: src
  });
});
setGlobal('svs.components.onboarding.imageHelpers.SvgImage', SvgImage);

 })(window);